<div class="flex flex-row space-x-8">
  <div class="flex flex-col p-4 bg-white shadow-sm rounded w-full">

    <div class="flex flex-row items-center justify-between mb-4">
      <span class="text-xl font-bold">Prescrições</span>
      <button mat-icon-button matTooltip="Acompanhar evolução" color="primary"
              routerLink="prescription/history">
        <mat-icon svgIcon="heroicons_outline:presentation-chart-line"></mat-icon>
      </button>
    </div>

    <ng-container *ngIf="loading$ | async; else showChart">
      <div class="w-full flex justify-center py-8">
        <mat-spinner></mat-spinner>
      </div>
    </ng-container>

    <ng-template #showChart>
      <apx-chart
        *ngIf="prescriptionChartOptions$ | async as opts"
        class="w-full h-full"
        [series]="opts.series"
        [chart]="opts.chart"
        [labels]="opts.labels"
        [legend]="opts.legend"
        [plotOptions]="opts.plotOptions">
      </apx-chart>
    </ng-template>

  </div>
</div>
